import React from "react";

import { Button, Stack, Typography } from "@mui/material";
import { CheckCircle, CloudUpload, Error, PieChart } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

import { MessageIcon } from "@/components/atoms";
import { ValidFile } from "@/types";

interface FilterBoxProps {
  currentFile: File | { name: string } | null;
  validFile: ValidFile | null;
  loading: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  allowSegments: boolean;
  disabled?: boolean;
}

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const FileUpload: React.FC<FilterBoxProps> = ({
  currentFile,
  validFile,
  loading,
  onChange,
  allowSegments,
  disabled = false,
}) => {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Button
        component="label"
        role={undefined}
        variant="contained"
        color="secondary"
        startIcon={<CloudUpload />}
        loading={loading}
        disabled={disabled}
      >
        Upload
        <VisuallyHiddenInput
          type="file"
          accept="text/csv"
          onChange={onChange}
        />
      </Button>
      <Typography>
        {currentFile ? currentFile.name : "Select a File to upload (Max 150Mb)"}
      </Typography>
      {validFile ? (
        validFile.error ? (
          <MessageIcon
            Icon={Error}
            color="error"
            message="There was a problem processing this file"
          />
        ) : validFile.format ? (
          <>
            <MessageIcon
              Icon={CheckCircle}
              color="success"
              tooltip="The file format is valid"
            />
            {allowSegments && validFile.segment && (
              <MessageIcon
                Icon={PieChart}
                color="info"
                tooltip="The file contains segments"
              />
            )}
          </>
        ) : (
          <MessageIcon
            Icon={Error}
            color="error"
            message="The file format is invalid"
          />
        )
      ) : null}
    </Stack>
  );
};

export default FileUpload;
